import ReferenceDisplay from '../../../../../reference/ReferenceDisplay';

const ReactReferenceDisplayGrapeJs = (props) => {
    return <ReferenceDisplay maximum={0} {...props} />;
};

export default (editor) => {
    const domComponents = editor.DomComponents;

    domComponents.addType('reactReferenceDisplay', {
        extend: 'react-component',
        model: {
            defaults: {
                component: ReactReferenceDisplayGrapeJs,
                stylable: false,
                resizable: false,
                editable: false,
                draggable: false,
                droppable: false,
                hoverable: false,
                selectable: false,
                attributes: {
                    editable: false,
                },
                traits: [],
            },
        },
        isComponent: (el) => el.tagName === 'REACTREFERENCEDISPLAY',
    });
};
